module.exports = __webpack_public_path__ + "img/1-attic-floor.5786e946.svg";